function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.4148421mm",
    height: "5.938118mm",
    viewBox: "0 0 4.4148421 5.938118",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.948102,-96.612412)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 28.673103,100.23985 q 0.01172,-0.476567 0.01563,-0.949223 0.0078,-0.472657 0.0078,-0.929688 v -0.597656 q -0.550781,0.699219 -1.234375,1.5 -0.679688,0.796877 -0.679688,0.874997 0,0.0703 0.08594,0.10157 0.08594,0.0273 0.316406,0.0273 0.05859,0 0.230469,-0.004 0.175781,-0.004 0.289062,-0.004 0.140625,0 0.621094,-0.0117 0.222656,-0.004 0.347656,-0.008 z m -0.01953,0.57031 q -0.582031,0 -1.226562,-0.0117 -0.164063,-0.004 -0.203125,-0.004 -0.351563,0 -0.589844,0.0195 -0.234375,0.0156 -0.359375,0.0508 -0.117188,-0.12891 -0.171875,-0.2461 -0.05469,-0.11719 -0.05469,-0.24219 0,-0.33593 1.03125,-1.507808 0.488282,-0.558594 0.777344,-0.898438 0.05859,-0.07422 0.171875,-0.207031 0.875,-1.050781 1.171875,-1.050781 0.117188,0 0.164063,0.08203 0.05078,0.07813 0.05078,0.296875 0,0.05859 -0.01953,0.335937 -0.09375,1.339844 -0.09375,2.621096 v 0.17578 q 0.289062,0 0.503906,-0.0352 0.214844,-0.0391 0.355469,-0.11328 0.05078,0.10938 0.07422,0.19922 0.02734,0.0859 0.02734,0.16016 0,0.21875 -0.140625,0.3125 -0.140625,0.0937 -0.472656,0.0937 -0.08594,0 -0.289063,-0.0117 -0.03125,-0.004 -0.04687,-0.004 0.0039,0.28907 0.01172,0.67578 0.01172,0.38282 0.01172,0.47657 0,0.26562 -0.07422,0.36718 -0.07031,0.10547 -0.246094,0.10547 -0.113281,0 -0.257812,-0.0469 -0.140625,-0.0469 -0.320313,-0.13672 0.105469,-0.19141 0.15625,-0.54688 0.05469,-0.35937 0.05859,-0.91015 z",
    style: {
      fontSize: 8,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit4);
export default __webpack_public_path__ + "static/media/digit-4.0b849b2f6d73d2c3c05e711bef1f2982.svg";
export { ForwardRef as ReactComponent };